/**
 * Main App component with routing between lessons and sandbox.
 *
 * Routes:
 * - / : Tutorial/lesson view
 * - /sandbox : Dedicated sandbox experience with simulation controls
 */

import { lazy, Suspense } from 'react'
import { Routes, Route } from 'react-router-dom'
import { LessonsPage } from './pages/LessonsPage'
import { WelcomeModal } from './components/layout/WelcomeModal'

const SandboxPage = lazy(() =>
  import('./pages/SandboxPage').then((m) => ({ default: m.SandboxPage }))
)

function App() {
  return (
    <>
    <WelcomeModal />
    <Routes>
      <Route path="/" element={<LessonsPage />} />
      <Route
        path="/sandbox"
        element={
          <Suspense fallback={<div className="flex min-h-screen items-center justify-center bg-background"><p className="text-muted-foreground">Loading sandbox...</p></div>}>
            <SandboxPage />
          </Suspense>
        }
      />
    </Routes>
    </>
  )
}

export default App
